import React, { createContext, useState, useContext, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmationDialog from '../ConfirmationDialog'; 

const SimulationContext = createContext();

export const useSimulation = () => useContext(SimulationContext);

export const SimulationProvider = ({ children }) => {
  const [isAnalyzingGlobal, setIsAnalyzingGlobal] = useState(false);
  const [stopAnalysisHandler, setStopAnalysisHandler] = useState(null);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [nextPath, setNextPath] = useState(null);
  const navigate = useNavigate();

  const promptNavigation = (path) => {
    if (isAnalyzingGlobal) {
      setNextPath(path);
      setIsConfirmOpen(true);
    } else {
      navigate(path);
    }
  };

  const handleConfirmStop = async () => {
    if (stopAnalysisHandler) {
      await stopAnalysisHandler();
    }
    setIsConfirmOpen(false);
    if (nextPath) {
      navigate(nextPath);
    }
  };

  const handleCancelStop = () => {
    setIsConfirmOpen(false);
    setNextPath(null);
  };

  const value = {
    isAnalyzingGlobal,
    setIsAnalyzingGlobal,
    setStopAnalysisHandler: useCallback((handler) => setStopAnalysisHandler(() => handler), []),
    promptNavigation,
  };

  return (
    <SimulationContext.Provider value={value}>
      {children}
      <ConfirmationDialog
        open={isConfirmOpen}
        onClose={handleCancelStop}
        onConfirm={handleConfirmStop}
        title="Stop Running Analysis?"
        message="Navigating away will stop the current analysis. Are you sure you want to continue?"
        // --- MODIFICATION: Add custom button text for clarity ---
        confirmText="Stop and Continue"
        cancelText="Stay on Page"
      />
    </SimulationContext.Provider>
  );
};